import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-center ga-2" }

import {computed, onMounted} from "vue";
import {useLotoAreaStore} from "@/api/loto";
import {planFullName} from "@/types/Loto";
import {useGlobalSetting} from "@/lib/utils";

/**
 * Auswahl eines Freischaltbereichs.
 *
 * Zwei Modi:
 * - filterMode=true  → Model ist ein Filter-String "=<id>" (für UniversalList-Spaltenfilter)
 * - filterMode=false → Model ist die loto_area_id (number | null) direkt (für Formulare)
 */

interface Props {
  filterMode?: boolean,
  label?: string,
  readonly?: boolean,
  disabled?: boolean,
  hideDetails?: boolean,
  density?: 'default' | 'comfortable' | 'compact',
  prependIcon?: string,
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LotoAreaSelect',
  props: /*@__PURE__*/_mergeModels({
    filterMode: { type: Boolean, default: false },
    label: { default: "Bereich" },
    readonly: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    hideDetails: { type: Boolean, default: true },
    density: { default: 'compact' },
    prependIcon: { default: "" }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props

const modelValue = _useModel<string | number | null>(__props, "modelValue");

const areaStore = useLotoAreaStore();

onMounted(() => {
  areaStore.load();
});

const items = computed(() => {
  // Nach Plan-Reihenfolge (Maschine → Ebene) gruppieren, innerhalb des Plans alphabetisch
  const planOrder = (planId: number) => {
    const index = areaStore.plans.findIndex(p => p.id === planId)
    return index === -1 ? Number.MAX_SAFE_INTEGER : index
  }
  const sorted = [...areaStore.areas].sort((a, b) =>
      planOrder(a.plan_id) - planOrder(b.plan_id) || a.name.localeCompare(b.name, 'de'))
  return sorted.map(area => ({
    title: area.name,
    value: area.id,
    color: area.color,
    subtitle: planFullName(areaStore.planById(area.plan_id)),
  }))
})

const internalValue = computed<number | null>({
  get() {
    if (!props.filterMode) return (modelValue.value as number | null) ?? null
    const raw = String(modelValue.value ?? '')
    const match = raw.match(/^=?(\d+)$/)
    return match ? Number(match[1]) : null
  },
  set(val: number | null) {
    if (!props.filterMode) {
      modelValue.value = val
    } else {
      modelValue.value = val != null ? `=${val}` : ''
    }
  }
})

return (_ctx: any,_cache: any) => {
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createBlock(_component_v_select, {
    modelValue: internalValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalValue).value = $event)),
    items: items.value,
    "item-title": "title",
    "item-value": "value",
    label: _ctx.label,
    clearable: "",
    "hide-details": _ctx.hideDetails,
    density: _ctx.density,
    variant: _unref(useGlobalSetting)().globalTextVariant,
    readonly: _ctx.readonly,
    class: _normalizeClass(_ctx.readonly ? 'custom-readonly' : ''),
    disabled: _ctx.disabled,
    "prepend-inner-icon-icon": _ctx.prependIcon
  }, {
    item: _withCtx(({ props: itemProps, item }) => [
      _createVNode(_component_v_list_item, _mergeProps(itemProps, {
        subtitle: item.raw.subtitle
      }), {
        prepend: _withCtx(() => [
          _createElementVNode("span", {
            class: "area-dot mr-2",
            style: _normalizeStyle({ backgroundColor: item.raw.color })
          }, null, 4)
        ]),
        _: 2
      }, 1040, ["subtitle"])
    ]),
    selection: _withCtx(({ item }) => [
      _createElementVNode("span", _hoisted_1, [
        _createElementVNode("span", {
          class: "area-dot",
          style: _normalizeStyle({ backgroundColor: item.raw.color })
        }, null, 4),
        _createElementVNode("span", null, _toDisplayString(item.raw.title), 1)
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "items", "label", "hide-details", "density", "variant", "readonly", "class", "disabled", "prepend-inner-icon-icon"]))
}
}

})